import { useTheme, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper } from "@mui/material";
import { StyledButton } from "../../components/StyledButton";
import { StyledBox } from "../../components/StyledBox";

export interface CredentialNotFoundProps {
    credentialId: string,
    handleReset: (e: React.MouseEvent<HTMLButtonElement>) => void,
}

const CredentialNotFound: React.FC<CredentialNotFoundProps> = ({credentialId,handleReset}) => {
    const theme = useTheme();

    return(
        <StyledBox>
            <TableContainer component={Paper}>
                <Table sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}} size="small">
                    <TableHead sx={{backgroundColor: theme.palette.primary.dark }}>
                        <TableRow>
                            <TableCell sx={{color: theme.palette.primary.contrastText }}>
                                Credential Not Found
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        <TableRow>
                            <TableCell sx={{borderBottom: "none"}}>
                                The credential with the credential ID '{credentialId}' that you have attempted to access could not be found. This is due to one of the following reasons:
                                <ul>
                                    <li>The credential does exist but has not been released for public access by the credential holder.</li>
                                    <li>The credential ID you entered does not exist in the system.</li>
                                </ul>
                                Please try entering the credential ID again. If that fails, contact the individual who provided you with the credential ID to make sure that it is correct and/or that the individual has activated and released the credential for public access
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" sx={{borderBottom: "none"}}>
                                <StyledButton type="submit" variant="contained" onClick={handleReset}>Reenter Credential ID</StyledButton>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </StyledBox>
    );
}

export default CredentialNotFound;